import { useState } from 'react';

import { listFileTags } from 'services/fileManager/fileManagerServices';

export default function useGetTags() {
  const [fullTags, setFullTags] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const getFileTags = async (case_id) => {
    setIsLoading(true);
    listFileTags(case_id, true)
      .then((response) => {
        if (response && response?.data) {
          setFullTags(response.data?.['file-tags']);
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return {
    getFileTags,
    fullTags,
    isLoading,
  };
}
